import { initSubRoutes } from '../../../../utils/router';

const RoutesAjouterPersona = initSubRoutes({
    route: '/ajouter-persona/',
    subroutes: {},
    nom: 'Ajouter une persona',
});

export default RoutesAjouterPersona;
